import React, { useEffect, useRef, useState } from "react";
import { Spin, Typography } from "antd";
import { apiFetch } from "../services/apiClient";

const { Text } = Typography;

/**
 * Handles the Google Drive OAuth callback at /auth/google/drive-callback?code=...
 * Exchanges the code for Drive tokens via the backend, then calls onComplete.
 */
const GoogleDriveCallback = ({ onComplete, onError }) => {
  const [status, setStatus] = useState("Connecting Google Drive…");
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const error = params.get("error");

    if (error) {
      onError?.(error === "access_denied" ? "Google Drive access was denied." : `Google error: ${error}`);
      return;
    }
    if (!code) {
      onError?.("No authorization code received from Google.");
      return;
    }

    setStatus("Authorizing Drive access…");
    apiFetch("/api/integrations/google-drive/callback", {
      method: "POST",
      body: { code },
    })
      .then(() => {
        setStatus("Google Drive connected!");
        setTimeout(() => onComplete?.(), 800);
      })
      .catch((err) => {
        onError?.(err?.message || "Drive connection failed. Please try again.");
      });
  }, []);

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "60vh", gap: 16 }}>
      <Spin size="large" />
      <Text type="secondary">{status}</Text>
    </div>
  );
};

export default GoogleDriveCallback;
